import React from 'react';
import classnames from 'classnames';

import { Button } from 'uikit/buttons';
import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/notice.module.scss';

const Notice = ({
  additionalText = '',
  className = '',
  buttonText = '',
  fontWeightModifier = '',
  hasAdditionalText = '',
  hasButton = false,
  hasIcon = false,
  icon = '',
  onClick = () => {},
  testId = '',
  text = '',
  variant = '',
}) => (
  <div data-testid={testId} className={classnames(styles.element, className)}>
    {hasIcon && createIconComponent({ icon, className: styles.icon })}
    <div className={styles.textWrap}>
      <Typo element="span" variant={variant || 'b01'} weight={fontWeightModifier}>
        {text}
      </Typo>
      {hasAdditionalText && (
        <Typo color="secondary" element="span" variant="b01">
          {additionalText}
        </Typo>
      )}
    </div>
    {hasButton && (
      <Button
        color="brand"
        onClick={onClick}
        size="small"
        testId="notice-button"
        text={buttonText}
        variant="link"
      />
    )}
  </div>
);

export default Notice;
